module.exports = __webpack_public_path__ + "static/media/medical_03.6bc4d730.jpg";